<template>
    <div>
        <v-container>
            <v-layout align-center justify-center row mb-2>
                <v-avatar size="100" color="grey lighten-4">
                    <img src="https://vuetifyjs.com/apple-touch-icon-180x180.png" alt="avatar">
                </v-avatar>
            </v-layout>
            <v-layout column>
                <v-flex>
                    adf
                </v-flex>
                <v-flex>
                    adf
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    export default {

    }
</script>

<style>

</style>